<template>
  <div class="wrapper">
    <ul class="current_user">
      <li>姓名：{{ selectdata.patientname }}</li>
      <li>就诊ID号：<span>{{ selectdata.patientId }}</span></li>
      <!-- <li>身份证：<span>{{ selectdata.idcardno.replace(/(\w{4})\w*(\w{4})/, "$1******$2") }}</span></li> -->
      <!-- <div class="qiehuan"><van-icon name="exchange" /></div> -->
      <span @click="showNation = true" class="switch">切换就诊人</span>
      <img src="@/assets/record/jkm2.png" @click.stop="cardbtn(selectdata)"/>
    </ul>
    <van-tabs v-model="active" title-active-color="#3C9ECF" swipeable>
      <van-tab title="待缴费">
        <div v-if="wjsShow" class="wjf_cla">
          <ul class="infoClass">
            <li>
              <span><span style="letter-spacing: 6px;">就诊人</span>：</span>
              <span>{{ wjsData[0].PatName }}</span>
            </li>
            <li>
              <span>开单日期：</span>
              <span style="letter-spacing: 0px;">{{ wjsData[0].RecipeDate }}</span>
            </li>
            <li>
              <span>就诊医生：</span>
              <span>{{ wjsData[0].DoctName }}</span>
            </li>
            <li>
              <span>就诊科室：</span>
              <span>{{ wjsData[0].DeptName }}</span>
            </li>
            <li>
              <span><span style="letter-spacing: 6px;">总金额</span>：</span>
              <span><span style="color: #CD3333;margin-right: 4px">{{ wjsData[0].RecipeAmount }}</span>元</span>
            </li>
          </ul>
          <ul class="wjslist">
            <li  class="wjslist_title">
              <span>项目名称</span>
              <span>单价(元)</span>
              <span>数量</span>
              <span>单位</span>
              <span>金额(元)</span>
            </li>
            <li class="list" v-for="(item, index) in wjsData[0].Items" :key="index">
              <span>{{ item.ItemName }}</span>
              <span>{{ item.Price }}</span>
              <span>{{ item.Num }}</span>
              <span>{{ item.Unit }}</span>
              <span>{{ item.Amount }}</span>
            </li>
          </ul>
        </div>
        <div class="yygh" @click="payment2" v-if="wjsShow">
          <van-button type="info">缴&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;费</van-button>
        </div>
        <div class="empty_cl" v-if="!wjsShow">
          <img src="@/assets/bg/empty.png">
          <!-- <span>暂无缴费记录</span> -->
        </div>
      </van-tab>
      <van-tab title="缴费记录">
        <div class="content">
          <div class="time_date">
            <span style="margin-right: 6px">{{ daystartDate }} 至 {{ dayendDate }}</span>
            <van-icon name="notes-o" size="26" @click="selectTime" />
          </div>
          <div v-if="showList">
            <ul class="records" v-for="item in recordList" :key="item.billNo" @click="push(item)">
              <li>缴费类别：<span>{{ item.chargeType }}</span></li>
              <li>&nbsp;总&nbsp;金&nbsp;额：<span>{{ item.costs }}</span> 元</li>
              <li>就诊时间：<span>{{ item.visitDate }}</span></li>
              <li>缴费时间：<span>{{ item.sfsj }}</span></li>
              <img src="@/assets/appointment/xsj_r.png">
            </ul>
          </div>
        </div>
        <div class="empty_cl" v-if="!showList">
          <img src="@/assets/bg/empty.png">
          <span>暂无缴费记录</span>
        </div>
        <van-calendar
          v-model="showMoreSel"
          type="range"
          @confirm="onConfirmMore"
          color="#318fe6"
          :min-date="minDate"
          :max-date="maxDate"
          :default-date="[new Date(daystartDate),new Date(dayendDate)]"
        />
      </van-tab>
    </van-tabs>
    <van-popup v-model="showNation" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirmNation"
        @cancel="showNation = false"
      />
    </van-popup>
    <judgment></judgment>
  </div>
</template>

<script>
import { selectVisitinfos, getPayedRecipe, GetPaymentOpChargeDtl, pay } from "@/request/api.js";
import { throttle, debounce } from "@/tool/shake.js";
import Judgment from "@/components/Judgment/Judgment.vue";
export default {
  components: {
    Judgment
  },
  data() {
    return {
      showNation: false,
      columns: [],
      selectdata: {
        idcardno: ""
      },
      active: 0,
      wjsShow: false,
      showList: false,
      showMoreSel: false,
      minDate: "",
      maxDate: "",
      daystartDate: "",
      dayendDate: "",
      recordList: [],
      wjsData: [],
      num: 4
    }
  },
  created() {
    this.payment2 = debounce(this.payment,400);
  },
  mounted() {
    this.getVisitinfos()
  },
  methods: {
    // 获取所有就诊人
    async getVisitinfos() {
      let openid = sessionStorage.getItem("openid");
      let res = await selectVisitinfos({ openid });
      this.columns = res.data.obj;
      res.data.obj.forEach(item => {
        item.text = item.patientname;
        if (item.style == 1) {
          this.selectdata = item;
        }
      });
      this.getUnpaid()
    },
    // 切换就诊卡
    onConfirmNation(value) {
      this.selectdata = value;
      this.showNation = false;
      this.getUnpaid();
      this.Toast("切换成功");
    },
    // 查看电子卡
    cardbtn(item){
      sessionStorage.setItem("card", JSON.stringify(item));
      this.$router.push("/HealthCard");
    },
    // 待缴费查询
    async getUnpaid(){
      let map = {
        patientId: this.selectdata.patientId,
        // patientId: "2691",
        userId: "7148"
      }
      let res = await GetPaymentOpChargeDtl(map);
      this.getDate()
      if(res.data.obj.resultData != null){
        console.log(res,1111)
        this.wjsData = res.data.obj.resultData
        this.wjsShow = true
      } else {
        this.wjsShow = false
      }
    },
    // 获取门诊费用记录
    async getPayed(){
      let map = {
        endDate: this.dayendDate,
        patientID: this.selectdata.patientId,
        // patientID: 715545,
        startDate: this.daystartDate
      }
      let res = await getPayedRecipe(map);
      if(res.data.obj.resultData == null) return;
      res.data.obj.resultData.forEach(item => {
        item.visitDate = item.visitDate.replace(/\s{2}/g," ");
        item.visitDate = item.visitDate.split(" ")
        item.visitDate = item.visitDate[2] +'-'+ item.visitDate[0].toString().padStart(2,'0') +'-'+ item.visitDate[1].toString().padStart(2,'0')
        item.sfsj = item.sfsj.replace(/\s{2}/g," ");
        item.sfsj = item.sfsj.split(" ")
        item.sfsj = item.sfsj[2] +'-'+ item.sfsj[0].toString().padStart(2,'0') +'-'+ item.sfsj[1].toString().padStart(2,'0')
      });
      this.recordList = res.data.obj.resultData
      if(this.recordList != 0){
        this.showList = true
      } else {
        this.showList = false
      }
    },
    getDate(){
      this.minDate = new Date(this.$moment(new Date()).subtract(10, 'year').format('YYYY-MM-DD'));
      this.maxDate = new Date();
      this.daystartDate = this.$moment(new Date()).subtract(6, 'month').format('YYYY-MM-DD')
      this.dayendDate = this.$moment(new Date()).format('YYYY-MM-DD')
      this.getPayed()
    },
    selectTime() {
      this.showMoreSel = true;
    },
    onConfirmMore(data) {
      this.showMoreSel = false;
      let [start,end] = data;
      this.daystartDate = this.$moment(start).format("YYYY-MM-DD");
      this.dayendDate = this.$moment(end).format("YYYY-MM-DD");
      // this.section = this.daystartDate + " 至 " + this.dayendDate;
      this.getPayed()
    },
    // 缴费
    async payment(){
      let map = {
        flag: 2, // 1=挂号缴费 2=门诊缴费 3=住院充值
        payTypeId: 1,
        orderDate: this.wjsData[0].RecipeDate.slice(0,10),
        orderTime: this.$moment().format("HH:mm:ss"),
        orderTimeoutDate: "",
        // orderNo: 1,
        currencyCode: 156,
        // orderAmount: 0.01,
        orderAmount: this.wjsData[0].RecipeAmount,
        payInDepositOrderPo: {}, // 入住院缴费实体
        payOpChargePo: {
          cardNo: this.wjsData[0].CardNo,
          mzRegID: this.wjsData[0].MzRegId,
          patientID: this.selectdata.patientId,
          // patientID: "2691", // 测试
          payAmount: this.wjsData[0].RecipeAmount,
        }, // 门诊缴费实体
        subsidAmount: "",
        expireDate: "",
        accountNo: "",
        openID: this.selectdata.openid,
        orderDesc: "医院公众号门诊缴费",
        receiverAddress: "",
        buyIp: ""
      }
      this.num++;
      let rs = await pay(map);
      let that = this;
      function onBridgeReady() {
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: rs.data.obj.sub_appId,
            timeStamp: rs.data.obj.timeStamp,
            nonceStr: rs.data.obj.nonceStr,
            signType: rs.data.obj.signType,
            paySign: rs.data.obj.paySign,
            package: rs.data.obj.package,
          },
          function (obj) {
            if (obj.err_msg == "get_brand_wcpay_request:ok") {
              if (res.data.message == "操作成功") {
                that.Toast.success("支付成功,即将返回门诊缴费页面");
                setTimeout(() => {
                  // that.$router.push("/home");
                  that.$router.go(1);
                }, 1500);
              } else if (obj.err_msg == "get_brand_wcpay_request:cancel") {
              } else {
              }
            }
          }
        );
      }
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        onBridgeReady();
      }
    },
    push(item){
      sessionStorage.setItem("payedRecipe", JSON.stringify(item));
      this.$router.push("/paymentRecordDetails");
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  overflow: auto;
  /deep/ .van-tabs {
    border-top: 1px solid #f9f9f9;
    border-bottom: 1px solid #f9f9f9;
    .van-tab__text--ellipsis {
      letter-spacing: 1px;
      font-size: 16px;
      font-weight: 600;
    }
    .van-tabs__line {
      background-color: #3c9ecf !important;
    }
  }
  /deep/ .current_user{
    position: relative;
    margin: 4px 4px 2px 4px;
    padding: 10px;
    background: #E6F5FC;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    >li{
      >span{
        letter-spacing: 0px;
      }
    }
    >li:nth-child(2){
      margin: 10px 0px;
    }
    .switch{
      position: absolute;
      top: 10px;
      right: 20px;
      color: #6098ff;
    }
    >img{
      position: absolute;
      width: 40px;
      right: 46px;
      bottom: 10px;
    }
  }
  .wjf_cla{
    border: 2px solid rgb(234, 234, 234);
    margin: 10px 10px 0px;
    .infoClass{
      background: #ffffff;
      padding: 8px 20px 0px;
      font-size: 14px;
      >li{
        padding-bottom: 8px;
        letter-spacing: 1px;
        >span:nth-child(1){
          font-weight: bold;
        }
        >span:nth-child(2){
          color: #666;
        }
      }
    }
    .wjslist{
      background: #fff;
      display: flex;
      flex-flow: column nowrap;
      font-size: 14px;
      >li{
        padding: 8px 10px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        text-align: center;
        justify-content: space-between;
        >span:nth-child(1){
          width: 120px;
          text-align: left;
        }
        >span:nth-child(2),>span:nth-child(5){
          width: 60px;
        }
        >span:nth-child(3){
          width: 38px;
        }
        >span:nth-child(4){
          width: 38px;
        }
      }
      .list{
        border-bottom: 1px solid #ddd;
      }
      .wjslist_title{
        background: #e0f2ff;
        font-weight: bold;
      }
    }
  }
  /deep/ .yygh{
    width: 355px;
    margin: 10px 10px 0px;
    background: rgb(83, 192, 255);
    color: rgb(255, 255, 255);
    .van-button{
      text-align: center;
      background: rgb(83, 192, 255);
      padding: 24px 0px;
      width: 355px;
      font-size: 20px;
      border-color: rgb(62, 184, 255);
    }
  }
  .content{
    .time_date {
      display: flex;
      font-size: 14px;
      padding: 12px 16px;
      color: #999;
      text-align: right;
      justify-content: flex-end;
      align-items: center;
    }
    .records{
      position: relative;
      margin: 10px 10px 0px 10px;
      padding: 10px;
      border-radius: 6px;
      background: #fff;
      font-size: 16px;
      color: #999;
      letter-spacing: 1px;
      // font-weight: bold;
      >li{
        margin-top: 4px;
        >span{
          letter-spacing: 0px;
          color: black;
        }
      }
      >li:nth-child(1){
        margin-top: 0px;
      }
      >img{
        position: absolute;
        top: 20px;
        right: 30px;
      }
    }
  }
  .empty_cl{
    text-align: center;
    >img{
      width: 100%;
    }
    >span{
      font-size: 16px;
      letter-spacing: 1px;
      color: rgba(153, 153, 153, 0.8);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/outpatientDepartment.vue